import { cn } from '../../utils/cn';
import { formatEUR } from '../../utils/money';

/**
 * Display monetary values in EUR with pt-PT formatting and tabular numerals.
 */
export function MoneyDisplay({
  value,
  compact = false,
  className,
  sign = false,
  size = 'md',
}) {
  const sizes = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-2xl',
    xl: 'text-4xl',
  };
  const display = formatEUR(value, { compact });
  const isPositive = typeof value === 'number' && value > 0;
  const isNegative = typeof value === 'number' && value < 0;
  const prefix = sign && isPositive ? '+' : '';

  return (
    <span
      data-money
      className={cn(
        'tnum font-numeric',
        sizes[size] || sizes.md,
        sign && isPositive && 'text-success-700',
        sign && isNegative && 'text-danger-700',
        className,
      )}
    >
      {prefix}
      {display}
    </span>
  );
}
